import type { NodeEntry } from 'platejs'
import { Range } from 'slate'

import type { BufferEditor } from '../BufferEditor/types.plate'

/**
 * Check whether the current selection is at the end of the current node.
 * If no node is provided, the current node under selection is used.
 */
export const isSelectionAtEndOfCurrentNode = (
  editor: BufferEditor,
  nodeEntry?: NodeEntry,
): boolean => {
  if (!editor.selection) return false

  const currentNode = nodeEntry ?? editor.api.node(editor.selection)
  if (!currentNode) return false

  const [, path] = currentNode
  const end = editor.api.end(path)
  if (!end) return false

  return Range.equals(editor.selection, {
    anchor: end,
    focus: end,
  })
}
